export default "__VITE_ASSET__0zoPVSAj__"